import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ReloadPromptPolicy {
  private baseline: string | null = null;
  private dismissed: { version: string } | null = null;

  setBaseline(version: string | null): void {
    this.baseline ??= version;
  }

  shouldPrompt(deployedVersion: string | null): boolean {
    if (this.baseline === null) {
      this.setBaseline(deployedVersion);
      return deployedVersion !== null;
    }
    // Strict inequality, so rollbacks prompt too.
    if (deployedVersion === null || deployedVersion === this.baseline) return false;
    return this.dismissed?.version !== deployedVersion;
  }

  recordDismissed(deployedVersion: string | null): void {
    if (deployedVersion === null) return;
    this.dismissed = { version: deployedVersion };
  }
}
